import React, { useEffect } from 'react';

const ColorTile = ({color, selected, setColor, updateStyleColor, firstLetters}) => {

    const handleChange = () => {
        updateStyleColor(color);
        setColor(parseInt(color.id));
    }

    useEffect(() => {
        if(firstLetters !== false && selected){
            if(firstLetters.length === 0){
                setColor(1);
            }
        }
    }, [firstLetters])

    return (
        <li className={firstLetters !== false && firstLetters.length === 0 ? 'hidden' : ''}>
            <input className='input-radio' type="radio" id={`color-${color.id}`} name="color-palette" value={color.id} checked={selected} readOnly onChange={handleChange} />
            <label className={color.name === "Multicolore" ? "multicolor" : ""} htmlFor={`color-${color.id}`} style={color.name === "Multicolore" ? {backgroundColor: `#${color.hex}`, backgroundImage:`url(./assets/images/rainbow.jpg)`, backgroundSize:`cover`} : {backgroundColor: `#${color.hex}`, borderColor: `#${color.hex}`}}></label>
        </li>
    );
};

export default ColorTile;